<template>
  <v-toolbar dense>
    <v-btn icon>
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <span class="font-weight-medium">平安成电智慧通行</span>
    <v-spacer></v-spacer>
    <v-btn icon>
      <v-icon>mdi-dots-horizontal</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {};
</script>

<style scoped>
.v-toolbar {
  background-color: #ededed !important;
  box-shadow: unset !important;
}

.v-icon {
  color: black !important;
}
</style>
